import { httpClient } from '@/httpClient/axios.ts';
import * as Sentry from '@sentry/browser';
import { useAppConfig } from '@/appConfig/useAppConfig.ts';
import { empty, isNil } from 'ramda';
import { useState } from 'react';
import { useForm } from '@/form/useForm.ts';

interface UseGridCheckApi {
  gridStatus: GridStatus;
  gridCheck: () => Promise<void>;
}

export type GridStatus = 'unknown' | 'checking' | 'usable' | 'used' | 'error';

export const useGridCheck = ({ spinnerDuration = 1000 }): UseGridCheckApi => {
  const appConfig = useAppConfig();
  const baseUrl = appConfig?.api.registrations || '';
  const { getFieldValue } = useForm();

  const gridId = getFieldValue('donorId');

  const [gridStatus, setGridStatus] = useState<GridStatus>('unknown');

  const gridCheck = () => {
    setGridStatus('checking');
    if (!baseUrl || empty(gridId) || isNil(gridId)) {
      setGridStatus('error');
      console.error('GRID check data error -- donorId:', gridId, ' baseURL: ', baseUrl);
      Sentry.captureException({ message: "GRID Check error: No 'check' url found or grid id empty. " });
      return Promise.reject();
    }

    const url = `${baseUrl}/${gridId}`;

    return httpClient
      .head(url)
      .then(() => {
        setTimeout(() => {
          setGridStatus('usable');
        }, spinnerDuration);
      })
      .catch((e) => {
        if (e.response && e.response.status === 409) {
          console.error('GRID already registered!');
          Sentry.captureException(e);
          setTimeout(() => {
            setGridStatus('used');
          }, 1000);
        } else {
          console.error('GRID check unknown error');
          Sentry.captureException(e);
          setTimeout(() => {
            setGridStatus('error');
          }, 1000);
        }
      });
  };

  return { gridCheck, gridStatus };
};
